module.exports = __webpack_public_path__ + "img/success.661230f6.png";